import { PayloadRequest } from 'types/requestTypes';

import { NomenclatureCustomNameCreate, NomenclatureCustomNameItem } from '../bus/nomenclatureCustomName/types';
import $axios from '../utils/axios-instance';

export default class NomenclatureCustomNameApi {
  async getNomenclatureCustomNameDetail({ id }: PayloadRequest) {
    return await $axios
      .get<NomenclatureCustomNameItem>(`/v1/NomenclatureCustomName/${id}/info`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getNomenclatureCustomNameCreate(data: NomenclatureCustomNameCreate) {
    return await $axios
      .post(`/v1/NomenclatureCustomName/${data.nomenclatureId}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getNomenclatureCustomNameEdit(data: NomenclatureCustomNameItem) {
    return await $axios
      .put(`/v1/NomenclatureCustomName/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getNomenclatureCustomNameDelete({ id }: PayloadRequest) {
    return await $axios
      .delete(`/v1/NomenclatureCustomName/${id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
